import { render } from "./Icon.vue?vue&type=template&id=234fa700"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=234fa700&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__